<template>
  <v-card style="overflow: visible;" class="elevation-0">
    <v-toolbar flat color="white" density="compact">
      <v-text-field
          density="compact"
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          v-model="advanced_search.text_search"
          v-debounce:800ms.lock="showRecords"
          @click:clear="clearSearch"
          hide-details
          single-line
          flat
          clearable
          prepend-inner-icon="mdi-magnify">
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('search') }}</span>
        </template>
      </v-text-field>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.brand_name"
          :items="advanced_search_models.brand_name"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('brand') }}</span>
        </template>
      </v-autocomplete>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <BaseResizableColumns :forceHorizontal="true">
        <template #left>
          <v-card class="pa-5" rounded="xl" border="sm" variant="outlined">
            <v-row class="mt-0">
              <v-col cols="auto">
                <v-chip color="success" variant="tonal">
                  {{ articles_count }} {{ $store.getters.translate('articles') }}
                </v-chip>
              </v-col>
              <v-col cols="auto">
                <v-chip color="error" variant="tonal">
                  {{ sece_defects_count }} {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defects') }}
                </v-chip>
              </v-col>
              <v-col cols="auto">
                <v-chip color="warning" variant="tonal">
                  {{ non_sece_defects_count }} {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defects') }}
                </v-chip>
              </v-col>
            </v-row>
            <Draggable
                ref="tree"
                class="mtl-tree ma-5"
                :defaultOpen="false"
                v-model="records"
                :disableDrag="true"
                :disableDrop="true"
                indent="20"
                treeLine>
              <template #default="{ node, stat }">
                <div style="display: flex; align-items: center; width: 100%;">
                  <OpenIcon v-if="stat.children && stat.children.length" :open="stat.open" @click.native="stat.open = !stat.open"/>
                  <span v-if="node && node.type === 'article'" class="sm-normal text-primary  ma-3" style="cursor: pointer;" @click.stop="getArticleInfo(node.id)">
                    {{ node.name }}
                  </span>
                    <span v-else class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'">
                    {{ node.name }}
                  </span>
                  <v-chip v-if="node.amount_of_equipment" size="small" color="success" variant="tonal">
                    {{ node.amount_of_equipment }} {{ $store.getters.translate('articles') }}
                  </v-chip>
                  <v-chip v-if="node.amount_of_sece_defects" size="small" color="error" variant="tonal" class="ml-2">
                    {{ node.amount_of_sece_defects }} {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defects') }}
                  </v-chip>
                  <v-chip v-if="node.amount_of_non_sece_defects" size="small" color="warning" variant="tonal" class="ml-2">
                    {{ node.amount_of_non_sece_defects }} {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defects') }}
                  </v-chip>
                  <v-spacer/>
                  <template v-if="node.type === 'type'">
                    <v-chip v-if="preferred_articles.find(item => item.original_brand_id === node.brand_id && item.original_type === node.name)" @click="editPreferredArticle(node)" size="small" color="primary" variant="tonal">
                      {{ getPreferredArticleName(node) }}
                    </v-chip>
                    <base-action-button v-else @action="createPreferredArticle(node)">
                      <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                      {{ $store.getters.translate("create") }} {{ $store.getters.translate("preferredarticle") }}
                    </base-action-button>
                  </template>
                </div>
              </template>
            </Draggable>
          </v-card>
        </template>
        <template #right>
          <v-card v-if="selected_article" class="pa-5 position-sticky top-0" rounded="xl" border="sm" variant="outlined" style="overflow:auto; height:90vh">
            <v-toolbar flat color="white" density="compact">
              <v-spacer/>
              <base-link-button @action="$router.push('/articles/' + selected_article.id)">
                <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                {{ $store.getters.translate("article") }}
              </base-link-button>
            </v-toolbar>
            <v-carousel v-if="selected_article.files.find(item => item.content_type === 'image/png' || item.content_type === 'image/jpeg')" hide-delimiters>
              <v-carousel-item
                  v-for="(file, index) in selected_article.files.filter(item => item.content_type === 'image/png' || item.content_type === 'image/jpeg')"
                  :key="index"
                  :src="file.full_path"/>
            </v-carousel>
            <v-card-text>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.last_inspection_date">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('last_inspection_date') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.last_modification_date">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('last_modification_date') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.tag_number"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.tag_number.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('tag_number_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.description">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('description') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.brand"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.brand.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('brand') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.type">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('type') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.model">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('model') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.model_details">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('model_details') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.serial_number">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('serial_number') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="equipment_type_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('equipment_type_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.tag_number && selected_article.tag_number.location"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.tag_number.location.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('location_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.application"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.application.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('application_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.markering"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.markering.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('markering_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ip_solids">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ip_solids') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ip_water">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ip_water') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="line_voltage_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('line_voltage_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.power">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('power') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.nominal_current">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('nominal_current') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ambient_temperature_low">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ambient_temperature_low') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ambient_temperature_high">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ambient_temperature_high') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.year_of_installation">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('year_of_installation') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.year_of_fabrication">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('year_of_fabrication') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.sap_article_code">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('sap_article_code') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.replacement_article_code">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('replacement_article_code') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.phase_type">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('phase_type') }}</span>
                </template>
              </v-text-field>
              <div class="mt-3" style="display: flex;">
                <PhCheck v-if="selected_article.ce_marking" color="green" size="30"/>
                <PhX v-else color="red" size="30"/>
                <span class="pl-3 sm-normal" style="display: block; align-content: center;">{{ $store.getters.translate('ce_marking') }}</span>
              </div>
              <v-text-field
                  v-if="inspection_certificate"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="inspection_certificate.full_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('inspection_certificate_name') }}</span>
                </template>
              </v-text-field>
              <v-row class="mt-0" v-if="certificate_files.length > 0">
                <v-col>
                  <base-list-files
                      :page="page"
                      :parent_id="inspection_certificate.id"
                      :label="$store.getters.translate('certificate_files').toUpperCase()"
                      :files="certificate_files"
                      :multiple_files="true"
                      :deletable="false"
                      :create="false"/>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="selected_article.defects.length > 0">
                <v-col>
                  <v-toolbar flat color="white" density="compact">
                    <v-toolbar-title class="text-primary">{{ $store.getters.translate('defects').toUpperCase() }}</v-toolbar-title>
                  </v-toolbar>
                  <v-list density="compact">
                    <v-list-item v-for="(defect, index) in selected_article.defects" :key="index" color="primary">
                      <v-list-item-title style="white-space: unset !important">
                        <a class="sm-bold" :href="'/defects/' + defect.id" target="_blank">{{ defect.short_name }}</a>
                      </v-list-item-title>
                      <v-list-item-subtitle class="no-webkit-line-clamp">
                        <span class="tiny-normal">{{ defect.deviations_and_remarks }}</span>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </BaseResizableColumns>
    </v-card-text>
    <base-create-dialog modal_name="create_preferred_article" ref="create_preferred_article" :page="preferred_article_page" @refresh="getPreferredArticles"/>
    <base-edit-dialog modal_name="edit_preferred_article" ref="edit_preferred_article" :page="preferred_article_page" @refresh="getPreferredArticles"/>
  </v-card>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseListFiles from "./BaseListFiles";
import BaseLinkButton from "./BaseLinkButton";
import BaseResizableColumns from "./BaseResizableColumns";
import BaseActionButton from "./BaseActionButton";
import BaseCreateDialog from "./BaseCreateDialog";
import BaseEditDialog from "./BaseEditDialog";
import {PhArrowSquareOut, PhCheck, PhPlus, PhX} from "@phosphor-icons/vue";
import { Draggable, OpenIcon } from '@he-tree/vue';
import '@he-tree/vue/style/default.css';
import '@he-tree/vue/style/material-design.css';

export default {
  components: { PhPlus, PhX, PhCheck, PhArrowSquareOut, BaseEditDialog, BaseCreateDialog, BaseActionButton, BaseLinkButton, BaseListFiles, BaseResizableColumns, Draggable, OpenIcon },
  data() {
    return {
      page: helpFunctions.pages.articles,
      preferred_article_page: helpFunctions.pages.preferredarticles,
      all_records: [],
      records: [],
      advanced_search: {
        text_search: null,
        brand_name: null
      },
      advanced_search_models: {
        brand_name: []
      },
      selected_article: null,
      inspection_certificate: null,
      certificate_files: [],
      equipment_type_name: null,
      line_voltage_name: null,
      articles_count: 0,
      sece_defects_count: 0,
      non_sece_defects_count: 0,
      preferred_articles: [],
    };
  },
  created() {
    this.getPreferredArticles();
  },
  methods: {
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.brand_name && !this.advanced_search_models.brand_name.includes(record.brand_name)) {
          this.advanced_search_models.brand_name.push(record.brand_name);
        }
      });
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.advanced_search.brand_name) {
        sorted_array = sorted_array.filter(item => item.brand_name === this.advanced_search.brand_name);
      }
      if(this.advanced_search.text_search) {
        sorted_array = sorted_array.filter(item => item.type && item.type.toLowerCase().includes(this.advanced_search.text_search.toLowerCase()));
      }

      let temp_records = [];

      this.articles_count = 0;
      this.sece_defects_count = 0;
      this.non_sece_defects_count = 0;

      for (let i = 0; i < sorted_array.length; i++) {
        if(sorted_array[i].brand_name) {
          let brand_name = sorted_array[i].brand_name.toLowerCase();
          let type = sorted_array[i].type.toLowerCase();
          if (!temp_records[brand_name]) {
            temp_records[brand_name] = {
              id: "brand-" + sorted_array[i].brand_id,
              name: sorted_array[i].brand_name,
              type: "brand",
              amount_of_equipment: 1,
              amount_of_sece_defects: sorted_array[i].amount_of_sece_defects,
              amount_of_non_sece_defects: sorted_array[i].amount_of_non_sece_defects,
              children: []
            };
          }
          else {
            temp_records[brand_name].amount_of_equipment++;
            temp_records[brand_name].amount_of_sece_defects += sorted_array[i].amount_of_sece_defects;
            temp_records[brand_name].amount_of_non_sece_defects += sorted_array[i].amount_of_non_sece_defects;
          }

          if (!temp_records[brand_name].children[type]) {
            temp_records[brand_name].children[type] = {
              id: "type-" + type,
              name: sorted_array[i].type,
              type: "type",
              brand_id: sorted_array[i].brand_id,
              amount_of_equipment: 1,
              amount_of_sece_defects: sorted_array[i].amount_of_sece_defects,
              amount_of_non_sece_defects: sorted_array[i].amount_of_non_sece_defects,
              children: []
            };
          }
          else {
            temp_records[brand_name].children[type].amount_of_equipment++;
            temp_records[brand_name].children[type].amount_of_sece_defects += sorted_array[i].amount_of_sece_defects;
            temp_records[brand_name].children[type].amount_of_non_sece_defects += sorted_array[i].amount_of_non_sece_defects;
          }

          if (!temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name]) {
            temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name] = {
              id: "platform-" + sorted_array[i].root_asset_id,
              name: sorted_array[i].root_asset_name,
              type: "platform",
              amount_of_equipment: 1,
              amount_of_sece_defects: sorted_array[i].amount_of_sece_defects,
              amount_of_non_sece_defects: sorted_array[i].amount_of_non_sece_defects,
              children: []
            };
          }
          else {
            temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name].amount_of_equipment++;
            temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name].amount_of_sece_defects += sorted_array[i].amount_of_sece_defects;
            temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name].amount_of_non_sece_defects += sorted_array[i].amount_of_non_sece_defects;
          }

          temp_records[brand_name].children[type].children[sorted_array[i].root_asset_name].children.push({
            id: "article-" + sorted_array[i].id,
            name: sorted_array[i].name,
            type: "article",
            amount_of_sece_defects: sorted_array[i].amount_of_sece_defects,
            amount_of_non_sece_defects: sorted_array[i].amount_of_non_sece_defects,
          });

          this.articles_count++;
          this.sece_defects_count += sorted_array[i].amount_of_sece_defects;
          this.non_sece_defects_count += sorted_array[i].amount_of_non_sece_defects;
        }
      }

      this.records = Object.values(temp_records);
      this.records = this.$lodash.sortBy(this.records, "name");

      for (let i = 0; i < this.records.length; i++) {
        this.records[i].children = Object.values(this.records[i].children);
        this.records[i].children = this.$lodash.sortBy(this.records[i].children, "name");

        for (let x = 0; x < this.records[i].children.length; x++) {
          this.records[i].children[x].children = Object.values(this.records[i].children[x].children);
          this.records[i].children[x].children = this.$lodash.sortBy(this.records[i].children[x].children, "name");
        }
      }
    },
    async getPreferredArticles() {
      this.preferred_articles = await helpFunctions.getFullAdditionalModels(this.$toast, "preferredarticle");
    },
    createPreferredArticle(node) {
      this.$refs.create_preferred_article.load();
      this.$refs.create_preferred_article.record.original_brand_id = node.brand_id;
      this.$refs.create_preferred_article.record.original_type = node.name;
    },
    editPreferredArticle(node) {
      let preferred_article = this.preferred_articles.find(item => item.original_brand_id === node.brand_id && item.original_type === node.name);
      this.$refs.edit_preferred_article.load(preferred_article.id);
    },
    getPreferredArticleName(node) {
      let preferred_article = this.preferred_articles.find(item => item.original_brand_id === node.brand_id && item.original_type === node.name);
      return preferred_article.preferred_brand.name + ', ' + preferred_article.preferred_type;
    },
    async getArticleInfo(id) {
      if(id.includes("article-")) {
        let model_id = id.replace("article-", "");
        if(!this.selected_article || this.selected_article.id !== model_id) {
          this.selected_article = await helpFunctions.loadModel(this.$toast, this.page.name, model_id);
          if(this.selected_article.equipment_type) {
            this.equipment_type_name = this.$store.getters.translate(this.selected_article.equipment_type.name);
          }
          if(this.selected_article.line_voltage) {
            this.line_voltage_name = this.selected_article.line_voltage.voltage + " " + this.selected_article.line_voltage.ac_dc;
          }

          if(this.selected_article.defects) {
            this.selected_article.defects.forEach(defect => {
              defect.short_name = "Distr. device function: " + this.$store.getters.translate(defect.distribution_device_function_name);
              if (defect.distribution_panel_name) {
                defect.short_name += ", panel: " + defect.distribution_panel_name;
              }
              if (defect.circuit_number) {
                defect.short_name += ", circuit number: " + defect.circuit_number;
              }
              if (defect.drawing_number) {
                defect.short_name += ", drawing number: " + defect.drawing_number;
              }
            });
          }

          await this.getInspectionCertificateInfo();
        }
      }
    },
    async getInspectionCertificateInfo() {
      this.certificate_files = [];
      if(this.selected_article.inspection_certificate_id) {
        this.inspection_certificate = await helpFunctions.getOneFullAdditionalModel(this.$toast, "inspectioncertificate", this.selected_article.inspection_certificate_id, true);
        if (this.inspection_certificate.files && this.inspection_certificate.files.length > 0) {
          this.inspection_certificate.files.forEach((file) => {
            if (file.revision === this.selected_article.inspection_certificate_revision) {
              this.certificate_files.push(file);
            }
          });
        }
      }
      else {
        this.inspection_certificate = null;
      }
    },
    clearSearch() {
      this.advanced_search.text_search = null;
      this.showRecords();
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
.he-tree__open-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.active-highlight {
  background-color: #e0f7fa;
  border-radius: 5px;
}
.no-webkit-line-clamp {
  -webkit-line-clamp: unset !important;
}
</style>